import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Seo } from "../components/Seo";

export function ResetPasswordPage() {
  const { user, loading, updatePassword } = useAuth();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (password.length < 8) { setError(true); setMessage("Use pelo menos 8 caracteres."); return; }
    if (password !== confirmation) { setError(true); setMessage("As senhas não são iguais."); return; }
    setBusy(true);
    const result = await updatePassword(password);
    setBusy(false);
    setError(Boolean(result.error));
    setMessage(result.error ? "Não foi possível alterar a senha. Solicite um novo link." : "Senha atualizada com sucesso.");
  }

  return (
    <section className="password-page page-container">
      <Seo title="Redefinir senha | DoramaFlix" description="Defina uma nova senha para sua conta DoramaFlix." path="/redefinir-senha" />
      <div className="password-card"><p className="eyebrow">RECUPERAÇÃO SEGURA</p><h1>Definir nova senha</h1>
        {loading && <p role="status">Validando o link…</p>}
        {!loading && !user ? <><p>Este link é inválido ou expirou. Solicite uma nova recuperação na tela de entrada.</p><Link className="primary-button" to="/?entrar=1">Voltar para entrar</Link></> : !loading && <form onSubmit={submit}><label>Nova senha<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" minLength={8} required /></label><label>Confirmar nova senha<input type="password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoComplete="new-password" minLength={8} required /></label>{message && <p className={error ? "form-message error" : "form-message success"} role={error ? "alert" : "status"}>{message}</p>}<button className="primary-button" disabled={busy}>{busy ? "Salvando…" : "Salvar nova senha"}</button></form>}
      </div>
    </section>
  );
}
